import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { redirectPath } from '../../lib/apollo/cache';

const withRedirectPath = (ComponentToWrap: any) => {
  const WithAuthContext = (props: any) => {
    const redirectPathFromCache = useReactiveVar(redirectPath);
    return (
      <ComponentToWrap
        redirectPath={redirectPathFromCache}
        updateRedirect={redirectPath}
        {...props}
      />
    );
  };
  WithAuthContext.displayName = 'withRedirectPath';

  return WithAuthContext;
};

export default withRedirectPath;
